import { isEmail } from 'validator';

import { validateForUI } from 'common/helpers/jsonValidator';

const contactSchema = {
  type: 'object',
  properties: {
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    phone: { type: 'string' },
    email: { type: 'string' },
    comments: { type: 'string' }
  },
  required: ['firstName', 'lastName', 'phone', 'email', 'comments'],
  additionalProperties: false
};

export const validateSubmit = (form) => {
  const errors = validateForUI(contactSchema, form, customValidate(form));
  return errors;
};

const customValidate = (form) => {
  const errorArray = [];
  if (form.email && !isEmail(form.email)) {
    errorArray.push({
      field: 'email',
      message: 'Invalid Email'
    });
  }

  return errorArray;
};
